import cn from "classnames";

import "./RentalDuration.css";

const RentalDuration = (props) => {
  const { rentalDurationArray, rentalDuration, onChange } = props;

  const renderItem = (item) => {
    const { value } = item;
    const itemClasses = cn("rntr-duration__item", {
      "rntr-duration__item_active": value === rentalDuration,
    });
    return (
      <button
        className={itemClasses}
        onClick={() => onChange(value)}
        key={`rental-duration-${value}`}
      >
        {value === 1 ? (
          <>
            <p className="rntr-duration__label">TRY</p>
            <p className="rntr-duration__label rntr-duration__label_sm_try">
              ON
            </p>
          </>
        ) : (
          <>
            <p className="rntr-duration__label">{value}</p>
            <p className="rntr-duration__label rntr-duration__label_sm">days</p>
          </>
        )}
      </button>
    );
  };

  return (
    <div className="rntr-duration">
      <div className="rntr-duration__title">Rental duration</div>
      <div className="rntr-duration__list">
        {rentalDurationArray.map((item) => renderItem(item))}
      </div>
    </div>
  );
};

export default RentalDuration;
